import {
  Form,
  Spin,
  Table,
  Row,
  Input,
  Icon,
  Button,
  Dropdown,
  Menu,
  Popconfirm,
  Empty,
} from "antd";
import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import withSharedStateConsumer from "../../contexts/shared-state/withSharedStateConsumer";
import { CustomerService } from "../../services/customer/CustomerService";
import { handleError } from "../../utils/ErrorHandlers";
import Page from "../general/Page";
import "./Customer.css";
import Highlighter from "react-highlight-words";
import { showSuccessToast } from "../general/ToastHelper";
import { convertTZToLocal } from "../general/DateTzHelper";
import history from "../../utils/history";

import CreateCustomerForm from "./createCustomerForm";
import Tickets from "../Tickets/Tickets";

import { Translation } from "react-i18next";
import i18next from "i18next";

class Customers extends Component {
  constructor(props) {
    super(props);
    this.props.context.setCurrentComponent("customers");
    this.state = {
      isFetching: false,
      data: [],
      visible: false,
      loading: false,
      searchText: "",
      edit: false,
      customerData: null,
      recordData: null,
      isCustomerTickets: false,
      customerId: "",
      searchedColumn: "",
    };
    this.customerService = new CustomerService();
  }

  componentDidMount() {
    this.getAllCustomers();
    this.setState({ edit: false });
  }
  componentDidUpdate(prevProps) {
    if (prevProps.location.key !== this.props.location.key) {
      this.componentDidMount();
    }
  }

  async getAllCustomers() {
    try {
      this.setState({ isFetching: true });

      let data = await this.customerService.getAllCustomersService(
        this.props.context.session_id,
        this.props.context.user.accountId
      );
      this.setState({ data: this.formatData(data), isFetching: false });
    } catch (e) {
      this.setState({ isFetching: false });

      handleError(e);
    }
  }
  handleRefresh() {
    this.getAllCustomers();
  }

  async deleteRecord(record) {
    try {
      let data = await this.customerService.deleteCustomer(
        this.props.context.session_id,
        record.customerId
      );
      showSuccessToast(i18next.t("Customer deleted successfully"));
      this.handleRefresh();
    } catch (e) {
      handleError(e);
    }
  }

  // showCreateCustomerForm = () => {
  //   let { history } = this.props;
  //   history.push("/home/customers/create/" + this.props.context.user.accountId);
  // };

  addNewCustomer = () => {
    history.push("/home/customer/create");
  };

  handleCancel = (e) => {
    this.setState({
      visible: false,
    });
  };

  itemRender = (current, type, originalElement) => {
    if (type === "prev") {
      return (
        <a className="ant-pagination-item-link">
          <Icon
            type={this.props.context.curr_dir === "rtl" ? "right" : "left"}
          />
        </a>
      );
    }
    if (type === "next") {
      return (
        <a className="ant-pagination-item-link">
          <Icon
            type={this.props.context.curr_dir === "rtl" ? "left" : "right"}
          />
        </a>
      );
    }
    return originalElement;
  };
  renderActionDropdown(record) {
    const menu = (
      <Menu>
        <Menu.Item
          onClick={() => {
            this.setState({ edit: true, recordData: record });
          }}
        >
          <span>{i18next.t("Edit")}</span>
          <Icon className={"view-details-style"} type="edit" />
        </Menu.Item>
        {this.props.context.user.userType === "ADMIN" ? (
          <Menu.Item>
            <Popconfirm
              title={i18next.t("Are you sure delete this Customer?")}
              onConfirm={() => this.deleteRecord(record)}
              okText={i18next.t("Yes")}
              cancelText={i18next.t("No")}
            >
              <a href="#" style={{ color: "rgba(0, 0, 0, 0.65)" }}>
                {i18next.t("Delete")}
                <Icon className={"delete-account-style"} type="delete" />
              </a>
            </Popconfirm>
          </Menu.Item>
        ) : null}
      </Menu>
    );
    return (
      <Dropdown overlay={menu}>
        <Button size="small" style={{ borderWidth: 0 }}>
          <Icon item={record} type="more" />
        </Button>
      </Dropdown>
    );
  }
  getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={(node) => {
            this.searchInput = node;
          }}
          placeholder={i18next.t(`Search ${dataIndex}`)}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => {
            this.setState({ searchedColumn: dataIndex });
            this.handleSearch(selectedKeys, confirm);
          }}
          style={{ width: 188, marginBottom: 8, display: "block" }}
        />
        <Button
          type="primary"
          onClick={() => {
            this.setState({ searchedColumn: dataIndex });

            this.handleSearch(selectedKeys, confirm);
          }}
          icon="search"
          size="small"
          style={
            this.props.context.curr_dir === "ltr" &&
            this.props.context.curr_lang === "en"
              ? { width: 100, marginRight: 8 }
              : { width: 100, marginLeft: 8 }
          }
        >
          {i18next.t("Search")}
        </Button>
        <Button
          onClick={() => this.handleReset(clearFilters)}
          size="small"
          style={{ width: 80 }}
        >
          {i18next.t("Reset")}
        </Button>
      </div>
    ),
    filterIcon: (filtered) => (
      <Icon type="search" style={{ color: "#d73a31" }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex] != null &&
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => this.searchInput.select());
      }
    },
  });

  handleSearch = (selectedKeys, confirm) => {
    confirm();
    this.setState({ searchText: selectedKeys[0] });
  };
  handleReset = (clearFilters) => {
    clearFilters();
    this.setState({ searchText: "" });
  };

  formatData(data) {
    const updated_data = [];
    for (var i = 0; i < data.ivrList.length; i++) {
      var row = {};
      row["key"] = i + 1;
      row["name"] = data.ivrList[i]["customerFullname"];
      row["email"] = data.ivrList[i]["customerEmail"];
      row["mobileNumber"] = data.ivrList[i]["customerNumber"];
      row["segment"] = i18next.t(data.ivrList[i]["customerSegment"]);
      row["address"] = data.ivrList[i]["customerAddress"];
      row["createdOn"] = convertTZToLocal(data.ivrList[i]["createdOn"]);
      row["createdBy"] = data.ivrList[i]["createdBy"];
      row["customerId"] = data.ivrList[i]["customerId"];
      updated_data.push(row);
    }
    return updated_data;
  }
  showCustomerTickets(record) {
    let { history } = this.props;
    //history.customerId = record.customerId;
    //history.isCustomerTickets = this.state.isCustomerTickets;
    //history.push("/home/tickets/");
    this.setState({ isCustomerTickets: true, customerId: record.customerId });
  }

  render() {
    let { isFetching } = this.state;
    const columns = [
      {
        title: i18next.t("Name"),
        dataIndex: "name",
        key: "name",
        ...this.getColumnSearchProps("name"),

        render: (text) =>
          this.state.searchedColumn === "name" ? (
            <Highlighter
              highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
              searchWords={[this.state.searchText]}
              autoEscape
              textToHighlight={text}
            />
          ) : (
            text
          ),
      },
      {
        title: i18next.t("email"),
        dataIndex: "email",
        key: "email",
        ...this.getColumnSearchProps("email"),
        render: (text) =>
          this.state.searchedColumn === "email" ? (
            <Highlighter
              highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
              searchWords={[this.state.searchText]}
              autoEscape
              textToHighlight={text}
            />
          ) : (
            text
          ),
      },
      {
        title: i18next.t("mobile number"),
        dataIndex: "mobileNumber",
        key: "mobileNumber",
        ...this.getColumnSearchProps("mobileNumber"),
        render: (text) =>
          this.state.searchedColumn === "mobileNumber" ? (
            <Highlighter
              highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
              searchWords={[this.state.searchText]}
              autoEscape
              textToHighlight={text}
            />
          ) : (
            text
          ),
      },
      {
        title: i18next.t("segment"),
        dataIndex: "segment",
        key: "segment",
        ...this.getColumnSearchProps("segment"),
        render: (text) =>
          this.state.searchedColumn === "segment" ? (
            <Highlighter
              highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
              searchWords={[this.state.searchText]}
              autoEscape
              textToHighlight={text}
            />
          ) : (
            text
          ),
      },
      {
        title: i18next.t("address"),
        dataIndex: "address",
        key: "address",
      },
      {
        title: i18next.t("date"),
        dataIndex: "createdOn",
        key: "createdOn",
        ...this.getColumnSearchProps("createdOn"),
        render: (text) =>
          this.state.searchedColumn === "createdOn" ? (
            <Highlighter
              highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
              searchWords={[this.state.searchText]}
              autoEscape
              textToHighlight={text}
            />
          ) : (
            text
          ),
      },
      // {
      //   title: "created by",
      //   dataIndex: "createdBy",
      //   key: "createdBy",
      // },

      {
        title: i18next.t("Action"),
        dataIndex: "operation",
        render: (text, record) =>
          this.state.data.length >= 1
            ? this.renderActionDropdown(record)
            : null,
      },
      {
        title: i18next.t("Ticket"),
        dataIndex: "operation",
        render: (text, record) =>
          this.state.data.length >= 1 ? (
            <Button
              className="button-add-account"
              type="primary"
              size={"small"}
              onClick={() => {
                this.showCustomerTickets(record);
              }}
            >
              {i18next.t("View")}
            </Button>
          ) : null,
      },
    ];

    return (
      <Translation>
        {(t) => (
          <Page
            title={
              this.state.edit || this.state.isCustomerTickets
                ? null
                : t("Manage Customers")
            }
          >
            {isFetching ? (
              <Spin></Spin>
            ) : (
              <div>
                {this.state.isCustomerTickets ? (
                  <Tickets
                    isCustomerTickets={this.state.isCustomerTickets}
                    customerId={this.state.customerId}
                    back={() => {
                      this.setState({ isCustomerTickets: false });
                    }}
                  ></Tickets>
                ) : (
                  //<Row style={{ marginTop: "25px" }}></Row>
                  <div>
                    {this.state.edit ? (
                      <CreateCustomerForm
                        editMode={this.state.edit}
                        back={() => {
                          this.setState({ edit: false });
                          this.setState({ customerData: null });
                        }}
                        recordData={this.state.recordData}
                      ></CreateCustomerForm>
                    ) : (
                      <div>
                        <Button
                          className="button-add-account"
                          onClick={this.addNewCustomer}
                          icon="plus"
                        />
                        <span>{t("Add New Customer")} </span>
                        <Table
                          columns={columns}
                          bodyStyle={{
                            boxShadow: "0 2px 8px rgba(0, 0, 0, 0.15)",
                            borderRadius: "8px",
                            marginBottom: "25px",
                          }}
                          dataSource={this.state.data}
                          pagination={{
                            position: "bottom",
                            pageSize: 10,
                            itemRender: this.itemRender,
                          }}
                          bordered
                          locale={{
                            emptyText: (
                              <Empty
                                description={i18next.t("Empty")}
                                image={Empty.PRESENTED_IMAGE_SIMPLE}
                              />
                            ),
                          }}
                        />
                      </div>
                    )}
                  </div>
                )}
              </div>
            )}
          </Page>
        )}
      </Translation>
    );
  }
}
export default Form.create()(withSharedStateConsumer(withRouter(Customers)));
